import MarkdownIt from 'markdown-it';
import PageView from './PageView';
import type { Page } from '../../models/Page';

interface MarkdownPageViewProps {
    page: Page;
    modificationsOnly?: boolean;
    showWhitespaces?: boolean;
    key?: string | number;
}

export default function MarkdownPageView({
    page,
    modificationsOnly,
    showWhitespaces,
}: MarkdownPageViewProps) {
    const createItemViews = (items: string[]) => {
        const md = new MarkdownIt({
            breaks: true,
        });
        const html = md.render(items[0] || '');
        return (
            <div>
                <div dangerouslySetInnerHTML={{ __html: html }} />
            </div>
        );
    };

    return (
        <PageView
            page={page}
            modificationsOnly={modificationsOnly}
            showWhitespaces={showWhitespaces}
            createItemViews={createItemViews}
        />
    );
}
